import React, { useContext } from 'react';
export const LegacyThreadContext = React.createContext({ legacyThread: undefined });
export const useLegacyThreadContext = () => useContext(LegacyThreadContext);
